export default __webpack_public_path__ + "static/media/tekion-upload.68d0cf3a.png";